import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';

import { usePageTracking } from '../../../hooks/usePageTracking';
import { RADIO_STATION } from '../radio.config';
import { useRadio, useRadioMediaSession } from '../radio.hooks';
import { useRadioStore } from '../radio.store';
import { formatRadioItem } from '../radioFormat';
import { PlayButton } from './PlayButton';
import '../radio.css';

const NAV_ITEMS = [
  { to: '/', label: 'Radio' },
  { to: '/historia', label: 'Historia' },
  { to: '/o-radiu', label: 'O radiu' },
] as const;

const PLAYER_PATHS = ['/', '/radio'];

/** Pasek playera na podstronach - na stronie głównej player jest całym ekranem. */
function MiniPlayer(): JSX.Element {
  const currentItem = useRadioStore((state) => state.currentItem);

  return (
    <aside className="radio-mini" aria-label="Odtwarzacz">
      <PlayButton variant="compact" />
      <p className="radio-mini__title">
        {currentItem ? formatRadioItem(currentItem) : RADIO_STATION.name}
      </p>
    </aside>
  );
}

/**
 * Layout nowej części serwisu: Radio Adamowo.
 *
 * Trzyma wszystko, co musi działać niezależnie od podstrony: silnik radia,
 * metadane streamu i systemowe kontrolki multimediów.
 */
export function RadioShell(): JSX.Element {
  const { pathname } = useLocation();
  const onPlayerPage = PLAYER_PATHS.includes(pathname);

  usePageTracking();
  useRadio();
  useRadioMediaSession();

  return (
    <div className="radio-app">
      <div className="radio-backdrop" aria-hidden="true" />
      <a href="#main-content" className="radio-skip-link">
        Przejdź do treści
      </a>

      <header className="radio-header">
        <nav aria-label="Główna nawigacja" className="radio-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end
              className={({ isActive }) =>
                isActive || (item.to === '/' && onPlayerPage) ? 'is-active' : undefined
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main id="main-content" className="radio-main" tabIndex={-1}>
        <Outlet />
      </main>

      {!onPlayerPage && <MiniPlayer />}

      <footer className="radio-footer">
        <p>
          {RADIO_STATION.name}
          <span aria-hidden="true"> · </span>
          {RADIO_STATION.tagline}
        </p>
        <Link to="/archiwum">Archiwum Adamowo</Link>
      </footer>
    </div>
  );
}
